import React from 'react';

import './ReportInput.css';


const ReportInput = ({
  message,
  input: {
    onChange,
  },
}) => {
  return (
    <div className="reportInput_main">
      <div className="reportInput_message">
        { message }
      </div>
      <input
        className="reportInput_count"
        placeholder="0"
        type="text"
        onChange={onChange}
      />
    </div>
  );
};

export default ReportInput;



// WEBPACK FOOTER //
// ./src/components/ReportInput.js